export enum CardBrand {
  amex = 'amex',
  cartes_bancaires = 'cartes_bancaires',
  diners = 'diners',
  discover = 'discover',
  jcb = 'jcb',
  mastercard = 'mastercard',
  visa = 'visa',
  unionpay = 'unionpay',
  unknown = 'unknown',
}

export interface CreditCard {
  id: string;
  brand: CardBrand;
  last_4_digits: string;
  exp_month: number;
  exp_year: number;
}
